import { useEffect, useRef, useCallback } from 'react'

export function useThrottledResize(callback: () => void, delay: number = 100) {
	const timeoutRef = useRef<NodeJS.Timeout>()
	const callbackRef = useRef(callback)

	// Update callback ref when callback changes
	useEffect(() => {
		callbackRef.current = callback
	}, [callback])

	const throttledCallback = useCallback(() => {
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current)
		}

		timeoutRef.current = setTimeout(() => {
			requestAnimationFrame(() => {
				callbackRef.current()
			})
		}, delay)
	}, [delay])

	useEffect(() => {
		window.addEventListener('resize', throttledCallback, { passive: true })

		return () => {
			window.removeEventListener('resize', throttledCallback)
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current)
			}
		}
	}, [throttledCallback])
}
